<template>
    <v-container text-center fluid>
        <div class="loading" v-if="loading">
            <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
            ></v-progress-circular>
        </div>
        <div v-else>
            <v-layout wrap>
                <v-flex xs12 sm6>
                    <v-date-picker class="mt-2" full-width :events="exerciseDateList" :event-color="eventColor" :picker-date.sync="pickerMonth" dark v-model="pickerDate"></v-date-picker>
                </v-flex>
                <v-flex sm1>
                    <v-divider vertical class="hidden-sm-and-down"></v-divider>
                </v-flex>
                <v-flex xs12 sm5>
                    <template v-for="(item, index) in exercises">
                        <v-card dark :key="index" class="my-2 mx-auto">
                            <v-card-title class="subtitle-1">{{ item.name }}</v-card-title>
                            <v-divider class="mx-1"></v-divider>
                            <div class="pa-1">
                                <v-simple-table>
                                    <thead>
                                    <tr>
                                        <th class="text-left" style="width:10%">Set No.</th>
                                        <th class="text-left" style="width:30%">Weight</th>
                                        <th class="text-left" style="width:30%">Lifts</th>
                                        <th class="text-left" style="width:30%">INOL</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="detail in item.detail" :key="detail.set">
                                        <td class="text-left" style="width:30%">{{ detail.set }}</td>
                                        <td class="text-left" style="width:30%">{{ detail.weight }}</td>
                                        <td class="text-left" style="width:30%">{{ detail.lifts }}</td>
                                        <td class="text-left" style="width:40%">{{ detail.inol }}</td>
                                    </tr>
                                    </tbody>
                                    <thead>
                                    <tr>
                                        <th colspan="2" class="text-right" style="width:50%">Total INOL</th>
                                        <th colspan="2" class="text-center" style="width:50%">Intensity</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td colspan="2" class="text-right" style="width:50%">{{ item.inol }}</td>
                                        <td colspan="2" class="text-center" style="width:50%">{{ getLevel(item.inol) }}</td>
                                    </tr>
                                    </tbody>
                                </v-simple-table>
                            </div>
                        </v-card>
                    </template>
                </v-flex>
            </v-layout>
        </div>
    </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import moment from 'moment';
export default {
    name: 'DailyLog',
    data: () => ({
        pickerMonth: null,
        pickerDate: moment().format('YYYY-MM-DD'),
        loading: false,
        user: null,
        exerciseDateList: [],
        exercises: [],
        cacheList: {},
        colorMap: [
            'red',
            'pink',
            'purple',
            'deep-purple',
            'indigo',
            'blue',
            'light-blue',
            'cyan',
            'teal',
            'green',
            'light-green',
            'lime',
            'yellow',
            'amber',
            'orange',
            'deep-orange',
            'brown',
            'blue-grey',
            'grey',
            'black',
        ],
    }),
    beforeCreate() {
        /**
         * 새로고침 하거나, 브라우저를 껐다가 켜도 세션에서 사용자 정보를 읽어오기 때문에
         * beforeCreate에서 onAuthStateChanged를 등록해준다.
         */
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.user = user;
                this.fetchEvent(moment().format('YYYY-MM'));
            } else {
                this.user = null;
                this.$router.push({path: 'calculator'});
            }
        });
    },

    watch: {
        pickerDate: function(newDate, oldDate) {
            if (newDate !== oldDate) {
                this.exercises.length = 0;
                this.fetchData(newDate);
            }
        },
        pickerMonth: function(newDate, oldDate) {
            if (newDate !== oldDate) {
                this.exerciseDateList.length = 0;
                this.fetchEvent(newDate);
            }
        },
    },
    methods: {
        getLevel(inol){
            if (inol <= 0.4) {
                return 'Super Easy';
            } else if (inol <= 1) {
                return 'Optimal';
            } else if (inol <= 2) {
                return 'Tough';
            } else if (inol > 2) {
                return 'Crazy';
            }
        },
        eventColor(date) {
            let cache = this.cacheList[this.pickerMonth];
            if (!cache) return false;
            let exercises = cache.find(item => item.date === date)['exercises'].reduce((sum, val) => sum + val.name, '');
            let index = exercises.length;
            for (let x = 0; x < exercises.length; x++) {
                let code = exercises.charCodeAt(x);
                index += code * code + x * x;
            }
            index = index % this.colorMap.length;
            return this.colorMap[index];
        },
        fetchEvent(month) {
            if (!this.user) return;

            this.loading = true;

            if (this.cacheList[month]) {
                this.exerciseDateList = this.cacheList[month].map(item => item.date);
                return;
            }

            this.cacheList[month] = [];
            let monthCache = this.cacheList[month];

            month = month.replace(/-/gi, '');
            const begin = month + '00';
            const end = month + '31';

            this.loading = true;
            firebase
                .firestore()
                .collection('dayLogs')
                .doc(this.user.uid)
                .collection('day')
                .where(firebase.firestore.FieldPath.documentId(), '>=', begin)
                .where(firebase.firestore.FieldPath.documentId(), '<=', end)
                .get()
                .then(result => {
                    result.forEach(doc => {
                        let cacheData = {
                            date: moment(doc.id, 'YYYYMMDD').format('YYYY-MM-DD'),
                            exercises: [],
                        };
                        let data = doc.data();
                        for (let key in data) {
                            let exercise = {
                                name: key,
                            };
                            Object.assign(exercise, data[key]);
                            cacheData.exercises.push(exercise);
                        }
                        monthCache.push(cacheData);
                    });
                    this.exerciseDateList = monthCache.map(item => item.date);
                    this.fetchData(this.pickerDate);
                    this.loading = false;
                })
                .catch(err => {
                    //TODO: Error Handler
                    alert(JSON.stringify(err));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        fetchData(date) {
            const data = this.cacheList[this.pickerMonth].find(item => item.date === date);
            if (data) {
                this.exercises = data.exercises.slice(0);
            }
        },
    },
};
</script>

<style scoped></style>
